import { render, staticRenderFns } from "./NsFooterNav.vue?vue&type=template&id=5ed601d5&scoped=true&"
import script from "./NsFooterNav.vue?vue&type=script&lang=js&"
export * from "./NsFooterNav.vue?vue&type=script&lang=js&"
import style0 from "./NsFooterNav.vue?vue&type=style&index=0&id=5ed601d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed601d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed601d5')) {
      api.createRecord('5ed601d5', component.options)
    } else {
      api.reload('5ed601d5', component.options)
    }
    module.hot.accept("./NsFooterNav.vue?vue&type=template&id=5ed601d5&scoped=true&", function () {
      api.rerender('5ed601d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsFooterNav.vue"
export default component.exports